import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { showToast } from "../../../utils/toastUtils";
import { Add_MTP_Tour_Plan, addMTPForMonth, getMTPActions, getMtpDayBeatTown, getMTPDayById, getMtpDayCustomers, getMTPList, getMTPMonths, getMTPStatus, getTerritoriesForMTP, getTourPlanByMTPDayId, updateMTPStatus, UpdateMTPTourPlan } from "./MtpRepository";


export const useMTPListData = ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["MTP", params],
        queryFn: () => getMTPList(params),
        enabled: enable,
        retry: false,
    });
};
export const useMTPMonths = ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["MTP", params],
        queryFn: () => getMTPMonths(params),
        enabled: enable,
        retry: false,
    });
};

export const useMTPStatus = ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["MTP", params],
        queryFn: () => getMTPStatus(params),
        enabled: enable,
        retry: false,
    });
};

export const useMTPActions = ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["MTP"],
        queryFn: () => getMTPActions(),
        enabled: enable,
        retry: false,
    });
};
export const useAddMTPForMonth = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: addMTPForMonth,
        onSuccess: (data) => {
            showToast.success("MTP Month Added Successfully!");
            queryClient.invalidateQueries({ queryKey: ["MTP"] });
        },
        onError: (error) => {
            showToast.warning("Failed to Add MTP Month!");
        },
    });
};
export const useUpdateMTPForMonth = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({body }: {body: any }) =>
            updateMTPStatus(body),
        onSuccess: (data) => {
            showToast.success("Update MTP Month Successfully!");
            queryClient.invalidateQueries({ queryKey: ["MTP"] });
        },
        onError: (error) => {
            showToast.warning("Failed to Update MTP Month!");
        },
    });
};

export const useMTPDayByIdData= ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["MTP", params],
        queryFn: () => getMTPDayById(params),
        enabled: enable,
        retry: false,
    });
};

export const useMTPDayCustomers= ({enable= false,mtpDayId,beatID}:{enable:boolean,mtpDayId:number | undefined,beatID?:number|undefined}) => {
    return useQuery({
        queryKey: ["MTP_DAY_CUMSTOMERS",mtpDayId,beatID],
        queryFn: () => getMtpDayCustomers(mtpDayId,beatID),
        enabled:enable && !!mtpDayId,
        retry: false,
    });
};

export const useMtpDayBeatTown = ({enable= false,mtpDayId,agendaControlType }:{enable:boolean,mtpDayId:number | undefined,agendaControlType?:string}) => {
    return useQuery({
        queryKey: ["MTP_DAY_BEAT_TOWN",mtpDayId,agendaControlType],
        queryFn: () => getMtpDayBeatTown(mtpDayId,agendaControlType),
        enabled:enable && !!mtpDayId,
        retry: false,
    });
};
    

export const useGetTourPlanByMTPDayIdData= ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["MTP", params],
        queryFn: () => getTourPlanByMTPDayId(params),
        enabled: enable,
        retry: false,
    });
};

export const useGetTerritory= ({enable = false, positionID}: {enable: boolean,positionID:number }) => {
    return useQuery({
        queryKey: ["MTP_TERRITORY",positionID],
        queryFn: () => getTerritoriesForMTP(positionID),
        enabled: enable,
        retry: false,
    });
};


export const useAdd_MTP_Tour_Plan = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: {
      mtpDayId: number;
      agendaControlType: string;
      agendaId: number;
      territoryId: number;
      townId?: number | null;
      beatId?: number;
      outletOrgDataId?: number;
    }) =>
      Add_MTP_Tour_Plan(
        params.mtpDayId,
        params.agendaControlType,
        params.agendaId,
        params.territoryId,
        params.townId,
        params.beatId,
        params.outletOrgDataId
      ),

    onSuccess: () => {
      showToast.success("MTP tour plan is added successfully");
      queryClient.invalidateQueries({ queryKey: ["MTP"] });
    },

    onError: (error: any) => {
      showToast.warning(`Failed to Add tour plan ${error.response.data.message}`);
      console.error("Failed to add MTP tour plan", error.message);
    },
  });
};


export const Update_MTP_Tour_Plan = ()=>{
  
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn:UpdateMTPTourPlan,
    onSuccess:()=>{
        showToast.success('MTP Tour Plan Updated');
        queryClient.invalidateQueries({queryKey:['MTP']});
    },
    onError:(error:any)=>{
        showToast.error("Falid to Update MTP TourPlan");
        console.log(`Falied to Update MTP Tour Plan ${error.message}`);
    }
  })

}